import {
  FiVolume2,
  FiX,
  FiArrowRight,
  FiChevronLeft,
  FiChevronRight,
  FiCalendar,
  FiClock,
  FiBriefcase,
  FiCoffee,
  FiHome,
  FiFileText,
  FiCheckCircle,
  FiHeart,
  FiCreditCard,
  FiDownload,
  FiMapPin,
  FiGift,
  FiEye,
  FiUser,
} from "react-icons/fi";
import { FaSeedling } from "react-icons/fa";
import "./EmployeeDashboard.css";
import React, { useContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import swal from "sweetalert";
const EmployeeDashboard = () => {
  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const [attendanceStatus, setAttendanceStatus] = useState();
  const [attendanceSummary, setAttendanceSummary] = useState({});
  const [loading, setloading] = useState();
  const [wfhdashboard, setwfhdashboard] = useState([]);
  const [profile, setprofile] = useState([]);
  const [policy, setpolicy] = useState([]);
  const [crouselData, setCrouselData] = useState(null);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const today = format(new Date(), "PPPP");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [placeName, setPlaceName] = useState("");
  const { password, username } = billpunchbasicauth;
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const currentYear = new Date().getFullYear();

  const Attendancedata = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
          empid: user.userid,
          date: currentDate,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/CheckPresentAbsentStatus`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setAttendanceStatus(data.result);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const Getleavesdata = async (month) => {
    // console.log("Getleavesdata called with month:", month);
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: String(user.userid),
          firmid: String(user.firm_id),
          month: String(selectedMonth),
          year: String(currentYear),
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetLeaveBalance`,
        requestOptions,
      );
      const data = await res.json();
      if (
        data.status === "0" &&
        Array.isArray(data.data) &&
        data.data.length > 0
      ) {
        setAttendanceSummary(data.data[data.data.length - 1]);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Getwfhdata = async (month) => {
    // console.log("Getleavesdata called with month:", month); // Debug log
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: user.userid,
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetWorkFromHomeDashboard`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setwfhdashboard(data.data[0]);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };
  const Policy = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firmid: user.firm_id,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmPolicy`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setpolicy(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const openPdfInNewTab = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };
  useEffect(() => {
    Policy();
    getLocation();
    Attendancedata();
    Getwfhdata();
  }, []);
  useEffect(() => {
    Getleavesdata(selectedMonth);
  }, [selectedMonth]);
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };
  const showPosition = async (position) => {
    // console.log("Received position data:", position);
    setLatitude(position.coords.latitude);
    setLongitude(position.coords.longitude);
    // console.log("Latitude:", position.coords.latitude);
    // console.log("Longitude:", position.coords.longitude);

    setTransactionLoaderState(true);

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${position.coords.latitude}&lon=${position.coords.longitude}&format=json`,
      );
      const data = await response.json();
      // console.log("Geocoding Response:", data);
      if (data && data.display_name) {
        setPlaceName(data.display_name);
      } else {
        console.log("No display name found in geocoding response");
      }
    } catch (error) {
      console.error("Error fetching place name:", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const getEmployeeList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        token: user.login_token,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeProfileDetails`,
        requestOptions,
      );
      const apiData = await res.json();

      if (apiData.status === "0") {
        const result = apiData.data[0]?.result;
        const message = apiData.data[0]?.message;

        if (result === "N" && message === "Unauthorized! Please login again") {
          swal({
            title: "Session Expired",
            text: message,
            icon: "warning",
            button: "Login",
          }).then(() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = "/";
          });
          return;
        }

        setprofile(apiData.data[0]);
      } else {
        swal("Error", apiData.msg || "Failed to fetch profile", "error");
      }
    } catch (error) {
      console.log("error", error);
      swal("Error", "Something went wrong while fetching profile", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const GetCrousels = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firmid: user.firm_id }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetCrousels`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setCrouselData(data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayImageUrl, setOverlayImageUrl] = useState(null);

  const handleImageClick = (imageUrl) => {
    setOverlayImageUrl(imageUrl);
    setShowOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowOverlay(false);
    setOverlayImageUrl(null);
  };
  const [employeebirth, setemployeebirth] = useState([]);
  const getEmployeebirthday = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firmId: user.firm_id,
          }),
        },
      );

      const data = await res.json();

      if (data.status === "0") {
        setemployeebirth(data.data);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const formatDateWithoutYear = (date) => {
    return new Date(date)?.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
    });
  };
  const currentMonth = new Date()?.getMonth() + 1;
  const filteredBirthdays = employeebirth.filter((birth) => {
    const birthMonth = new Date(birth?.dob).getMonth() + 1;
    return birthMonth === currentMonth;
  });
  useEffect(() => {
    getEmployeeList();
    GetCrousels();
    getEmployeebirthday();
  }, []);
  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? "Good Morning" : hour < 17 ? "Good Afternoon" : "Good Evening";
  const profileImage = profile.image_url || user.profile_url;
  const announcement = crouselData?.data
    ?.map((item) => item.textMsg)
    .filter(Boolean)
    .join("  •  ");
  const companyName =
    profile.firm_name ||
    profile.company_name ||
    user.firm_name ||
    user.company_name ||
    user.organization ||
    "";

  return (
    <div className="ed-page mt-3">
      {showAnnouncement && announcement && (
        <div className="ed-announcement">
          <FiVolume2 />
          <p>{announcement}</p>
          <button
            type="button"
            aria-label="Dismiss announcement"
            onClick={() => setShowAnnouncement(false)}
          >
            <FiX />
          </button>
        </div>
      )}
      <div className="ed-grid">
        <div className="ed-column">
          <section className="ed-welcome">
            <div className="ed-welcome-copy">
              <p>{greeting},</p>
              <h1>
                Welcome back,
                <br />
                <span>{user.username}</span>
              </h1>
              {companyName && <p>{companyName}</p>}
              <Link to="/Employee/profile" className="ed-primary">
                View Profile
                <FiArrowRight />
              </Link>
            </div>
            <button
              type="button"
              className="ed-profile-photo"
              onClick={() => profileImage && handleImageClick(profileImage)}
              aria-label="View profile photo"
              disabled={!profileImage}
            >
              {profileImage ? (
                <img src={profileImage} alt={user.username || "Employee"} />
              ) : (
                <FiUser />
              )}
              <span />
            </button>
          </section>
          <WeeklyCalendar />
          <section className="ed-card ed-wfh">
            <h2>
              <span className="ed-icon">
                <FiHome />
              </span>
              Work From Home Status
            </h2>
            <div className="ed-wfh-grid">
              <div>
                <span className="ed-icon">
                  <FiFileText />
                </span>
                <div>
                  <p>Tasks Pending To Review</p>
                  <strong>{wfhdashboard?.pending_review ?? "—"}</strong>
                </div>
              </div>
              <div>
                <span className="ed-icon ed-green">
                  <FiCheckCircle />
                </span>
                <div>
                  <p>WFH Approval Pending</p>
                  <strong>{wfhdashboard?.pending_wfh ?? "—"}</strong>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="ed-column">
          <section className="ed-card ed-leave">
            <div className="ed-card-heading">
              <h2>
                <span className="ed-icon ed-green">
                  <FaSeedling />
                </span>
                Leave Summary
              </h2>
              <select
                aria-label="Leave summary month"
                value={selectedMonth}
                onChange={(event) =>
                  setSelectedMonth(Number(event.target.value))
                }
              >
                {monthNames.map((month, index) => (
                  <option key={month} value={index + 1}>
                    {month} {currentYear}
                  </option>
                ))}
              </select>
            </div>
            <div className="ed-leave-row">
              <span className="ed-icon">
                <FiCalendar />
              </span>
              <span>Final Paid Leave</span>
              <strong>
                {Number(attendanceSummary.pl_bal || 0).toFixed(2)}
              </strong>
            </div>
            <div className="ed-leave-row">
              <span className="ed-icon ed-pink">
                <FiHeart />
              </span>
              <span>Final Sick Leave</span>
              <strong>
                {Number(attendanceSummary.sl_bal || 0).toFixed(2)}
              </strong>
            </div>
          </section>
          <section className="ed-card ed-attendance">
            <h2>
              <span className="ed-icon">
                <FiCalendar />
              </span>
              <span>
                Today's Date<small>{today}</small>
              </span>
            </h2>
            <div className="ed-attendance-row">
              <FiUser />
              <strong>Attendance Status</strong>
              <span
                className={`ed-attendance-status ${attendanceStatus === "Present" ? "is-present" : attendanceStatus === "Absent" ? "is-absent" : ""}`}
              >
                ● {attendanceStatus || "—"}
              </span>
            </div>
          </section>
          <div className="ed-shortcuts">
            <Link to="/Employee/salary-slip" className="ed-shortcut">
              <span className="ed-icon">
                <FiCreditCard />
              </span>
              <div>
                <h3>Check Your Salary</h3>
                <p>View your latest salary slip and details</p>
              </div>
              <FiChevronRight />
            </Link>
            <a
              href={`https://billpunch.com/OfferLetter/pdfdownload.php?token=${user.login_token}`}
              download
              className="ed-shortcut ed-offer"
            >
              <span className="ed-icon ed-teal">
                <FiDownload />
              </span>
              <div>
                <h3>Download Your Offer Letter</h3>
                <p>Get a copy of your offer letter</p>
              </div>
              <FiChevronRight />
            </a>
          </div>
          <section className="ed-card ed-location">
            <div className="ed-card-heading">
              <h2>
                <span className="ed-icon">
                  <FiMapPin />
                </span>
                User Location
              </h2>
              {latitude != null && longitude != null && (
                <a
                  href={`https://www.google.com/maps?q=${latitude},${longitude}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Map
                  <FiArrowRight />
                </a>
              )}
            </div>
            <div className="ed-location-body">
              <span className="ed-icon">
                <FiBriefcase />
              </span>
              <p>{placeName || "Location not available"}</p>
            </div>
          </section>
        </div>
        <div className="ed-column">
          <section className="ed-card ed-policy">
            <div className="ed-card-heading">
              <h2>
                <span className="ed-icon ed-purple">
                  <FiFileText />
                </span>
                Company Policy
              </h2>
              <Link to="/Employee/policy">
                More
                <FiArrowRight />
              </Link>
            </div>
            <div className="ed-policy-list">
              {policy.length ? (
                policy.map((item, index) => (
                  <div
                    className="ed-policy-item"
                    key={item.pk_policy_id || index}
                  >
                    <span className="ed-icon ed-teal">
                      <FiFileText />
                    </span>
                    <div>
                      <h3>{item.policy_name}</h3>
                      <p>
                        Updated on:{" "}
                        {item.policy_indate
                          ? new Date(item.policy_indate).toLocaleDateString(
                              "en-GB",
                            )
                          : "—"}
                      </p>
                    </div>
                    <button
                      type="button"
                      aria-label={`View ${item.policy_name}`}
                      disabled={!item.image_url}
                      onClick={() => openPdfInNewTab(item.image_url)}
                    >
                      <FiEye />
                    </button>
                  </div>
                ))
              ) : (
                <p className="ed-empty">No company policies available.</p>
              )}
            </div>
          </section>
          <section className="ed-card ed-birthdays">
            <h2>
              <span className="ed-icon ed-orange">
                <FiGift />
              </span>
              Birthday
              <span className="ed-confetti" aria-hidden="true">
                ✧
              </span>
            </h2>
            <p className="ed-birthday-intro">
              Take a minute and congratulate
              <br />
              them on their special day!
            </p>
            <div className="ed-birthday-list">
              {filteredBirthdays.length ? (
                filteredBirthdays.map((birth, index) => (
                  <div className="ed-birthday-row" key={birth.emp_id || index}>
                    <span className={`ed-initial ed-color-${index % 5}`}>
                      {String(birth.firstname || "?")
                        .charAt(0)
                        .toUpperCase()}
                    </span>
                    <span>{birth.firstname}</span>
                    <time>{formatDateWithoutYear(birth.dob)}</time>
                  </div>
                ))
              ) : (
                <p className="ed-empty">No birthdays this month.</p>
              )}
            </div>
          </section>
        </div>
      </div>
      {showOverlay && overlayImageUrl && (
        <div
          className="ed-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Profile photo"
          onClick={handleCloseOverlay}
        >
          <button
            type="button"
            aria-label="Close profile photo"
            onClick={handleCloseOverlay}
          >
            <FiX />
          </button>
          <img src={overlayImageUrl} alt="Profile" />
        </div>
      )}
    </div>
  );
};

export default EmployeeDashboard;

const WeeklyCalendar = () => {
  const [anchor, setAnchor] = useState(() => new Date());
  const today = new Date();
  const start = new Date(anchor);
  start.setDate(start.getDate() - start.getDay());
  const moveWeek = (offset) =>
    setAnchor((current) => {
      const next = new Date(current);
      next.setDate(next.getDate() + offset * 7);
      return next;
    });
  return (
    <section className="ed-card ed-calendar">
      <div className="ed-card-heading">
        <h2>
          <span className="ed-icon">
            <FiCalendar />
          </span>
          Weekly Calendar
        </h2>
        <div className="ed-calendar-nav">
          <button
            type="button"
            aria-label="Previous week"
            onClick={() => moveWeek(-1)}
          >
            <FiChevronLeft />
          </button>
          <button
            type="button"
            aria-label="Next week"
            onClick={() => moveWeek(1)}
          >
            <FiChevronRight />
          </button>
          <button
            type="button"
            className="ed-today"
            onClick={() => setAnchor(new Date())}
          >
            Today
          </button>
        </div>
      </div>
      <div className="ed-week">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day, index) => {
          const date = new Date(start);
          date.setDate(date.getDate() + index);
          const isToday = date.toDateString() === today.toDateString();
          return (
            <div
              key={day}
              className={isToday ? "is-today" : ""}
              aria-current={isToday ? "date" : undefined}
            >
              <span>{day}</span>
              <strong>{date.getDate()}</strong>
            </div>
          );
        })}
      </div>
      <div className="ed-office">
        <h3>
          <FiClock />
          Office Hours
        </h3>
        <div className="ed-office-grid">
          <div>
            <span className="ed-icon">
              <FiBriefcase />
            </span>
            <p>
              Office Hours<strong>9:30 AM – 6:30 PM</strong>
            </p>
          </div>
          <div>
            <span className="ed-icon">
              <FiCoffee />
            </span>
            <p>
              Lunch Break<strong>1:00 PM – 1:45 PM</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
